'use client';

export { SchoolDetailsComponent as SchoolDetailsComponentB } from './SchoolDetailsComponent';
